const IconPhone = ({ size, color, ...props }) => (
    <svg width={size} height={size} viewBox="0 0 21 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M0 0V34H21V0H0ZM10.5 32.6127C10.1386 32.6137 9.78506 32.5121 9.48413 32.3208C9.1832 32.1295 8.94841 31.8571 8.80961 31.5381C8.67082 31.2192 8.63427 30.868 8.70451 30.5291C8.77475 30.1902 8.94864 29.8789 9.20418 29.6346C9.45973 29.3903 9.78537 29.2241 10.1399 29.1569C10.4944 29.0898 10.8618 29.1248 11.1955 29.2574C11.5291 29.3901 11.8141 29.6145 12.0142 29.9022C12.2143 30.1899 12.3206 30.5278 12.3195 30.8733C12.3209 31.1028 12.275 31.3304 12.1842 31.5429C12.0935 31.7554 11.9598 31.9487 11.7907 32.1118C11.6217 32.2748 11.4207 32.4043 11.1992 32.4929C10.9777 32.5816 10.7401 32.6275 10.5 32.6282V32.6127ZM19.4837 27.9537H1.51085V1.55298H19.4837V27.9537Z"
            fill={color}
        />
    </svg>
);

export default IconPhone;
